module.exports = __webpack_public_path__ + "img/heroPic.e52c1721.jpg";